(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lcw-slideshow-plus"] && !Shopify.designMode) return;
  try {
    
  /* LCW Slideshow Plus 1.9.2 — comportamento (altura limite por breakpoint) */
  class LcwHeroPlusSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lcw-track-plus]');
      this.viewport = this.querySelector('.lcw-hero-plus__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-lcw-slide-plus]'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.layout = this.dataset.layout || 'full_frame';
      this.isHints = this.layout === 'with_hints';
      this.pagStyle = this.dataset.pagStyle || 'dots';

      this.prevBtn = this.querySelector('.lcw-hero-plus__arrow--prev');
      this.nextBtn = this.querySelector('.lcw-hero-plus__arrow--next');
      this.paginationEl = this.querySelector('.lcw-hero-plus__pagination');
      this.pagItems = Array.from(this.querySelectorAll('[data-lcw-pag-item-plus]'));

      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.timer = null;
      this.paused = false;
      this.dragging = false;
      this.moved = false;
      this.startX = 0;
      this.curX = 0;
      this.threshold = 40;
      this.resizeRaf = null;
      this.baseOffset = 0;
      this.progressAnim = null;
      this.ac = new AbortController();
      this.single = this.slides.length <= 1;

      this.gaEnabled = this.dataset.ga === 'true';
      this.gaMethod = this.dataset.gaMethod || 'pixel';
      this.gaLocation = this.dataset.gaLocation || 'home_hero';
      this.viewed = new Set();
      this.inView = false;

      this.maxHeightD = parseInt(this.dataset.maxHeightD || 0, 10);
      this.maxHeightM = parseInt(this.dataset.maxHeightM || 0, 10);
      this.mqMobile = window.matchMedia('(max-width: 749px)');

      if (!this.autoplay) this.classList.add('lcw-hero-plus--no-autoplay');

      if (!this.single) {
        if (this.prevBtn) this.prevBtn.hidden = false;
        if (this.nextBtn) this.nextBtn.hidden = false;
        if (this.paginationEl) this.paginationEl.hidden = false;
        this.bindControls();
        this.bindDrag();
        this.bindKeys();
        this.bindAutoplayGuards();
      }
      this.bindEditorEvents();
      this.bindHeightWatchers();
      this.bindTracking();

      this.goTo(0, false);
      if (this.autoplay && !this.single && !this.reduceMotion) this.start();
    }

    bindControls() {
      const sig = { signal: this.ac.signal };
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.restart(); }, sig);
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.restart(); }, sig);
      this.pagItems.forEach((it) => {
        it.addEventListener('click', () => { this.goTo(parseInt(it.dataset.lcwPagItemPlus, 10)); this.restart(); }, sig);
      });
    }

    bindKeys() {
      if (!this.hasAttribute('tabindex')) this.tabIndex = 0;
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.prev(); this.restart(); }
        else if (e.key === 'ArrowRight') { this.next(); this.restart(); }
      }, { signal: this.ac.signal });
    }

    bindDrag() {
      const vp = this.viewport;
      const sig = { signal: this.ac.signal };
      vp.addEventListener('touchstart', (e) => this.dragStart(e.touches[0].clientX), { passive: true, signal: this.ac.signal });
      vp.addEventListener('touchmove', (e) => this.dragMove(e.touches[0].clientX), { passive: true, signal: this.ac.signal });
      vp.addEventListener('touchend', () => this.dragEnd(), sig);
      vp.addEventListener('mousedown', (e) => {
        if (e.target.closest('button, a, input, select, textarea')) return;
        this.dragStart(e.clientX); e.preventDefault();
      }, sig);
      window.addEventListener('mousemove', (e) => { if (this.dragging) this.dragMove(e.clientX); }, sig);
      window.addEventListener('mouseup', () => { if (this.dragging) this.dragEnd(); }, sig);
      vp.addEventListener('click', (e) => {
        if (this.moved) { e.preventDefault(); e.stopPropagation(); this.moved = false; }
      }, { capture: true, signal: this.ac.signal });
    }

    dragStart(x) {
      this.dragging = true; this.moved = false;
      this.startX = x; this.curX = x;
      this.track.style.transition = 'none';
      this.stop();
    }
    dragMove(x) {
      if (!this.dragging) return;
      this.curX = x;
      const diff = x - this.startX;
      if (Math.abs(diff) > 5) this.moved = true;
      if (this.isHints) {
        this.track.style.transform = `translateX(${-this.baseOffset + diff}px)`;
      } else {
        this.track.style.transform = `translateX(calc(${-this.index * 100}% + ${diff}px))`;
      }
    }
    dragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.style.transition = '';
      const diff = this.curX - this.startX;
      if (diff < -this.threshold) this.next();
      else if (diff > this.threshold) this.prev();
      else this.goTo(this.index);
      this.restart();
    }

    goTo(i, animate = true) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      if (!animate) this.track.style.transition = 'none';

      if (this.isHints) {
        const target = this.slides[this.index];
        const cs = getComputedStyle(this.track);
        const padding = parseFloat(cs.paddingInlineStart || cs.paddingLeft) || 0;
        this.baseOffset = target.offsetLeft - padding;
        this.track.style.transform = `translateX(-${this.baseOffset}px)`;
      } else {
        this.track.style.transform = `translateX(${-this.index * 100}%)`;
      }

      if (!animate) { void this.track.offsetHeight; this.track.style.transition = ''; }

      this.pagItems.forEach((it, di) => {
        const active = di === this.index;
        it.classList.toggle('is-active', active);
        if (active) it.setAttribute('aria-selected', 'true');
        else it.removeAttribute('aria-selected');
      });

      this.adaptHeight();
      this.applyA11y();
      this.playActiveVideo();
      this.trackView(this.index);
      this.resetTimelineProgress();
      if (this.autoplay && !this.reduceMotion && !this.paused) this.startTimelineProgress();
    }
    next() { this.goTo(this.index + 1); }
    prev() { this.goTo(this.index - 1); }

    hasMaxHeightActive() {
      const isMobile = this.mqMobile.matches;
      return isMobile ? this.maxHeightM > 0 : this.maxHeightD > 0;
    }

    adaptHeight() {
      // Quando max-height está ativo no breakpoint atual, deixa o CSS controlar
      // (aspect-ratio + max-height + object-fit cover). Limpa qualquer style.height inline.
      if (this.hasMaxHeightActive()) {
        this.viewport.style.removeProperty('height');
        return;
      }
      const active = this.slides[this.index];
      if (!active) return;
      const h = active.offsetHeight;
      if (h > 0) this.viewport.style.height = h + 'px';
    }

    bindHeightWatchers() {
      const sig = { signal: this.ac.signal };
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.adaptHeight(), sig);
      });
      this.querySelectorAll('video').forEach((v) => {
        v.addEventListener('loadedmetadata', () => this.adaptHeight(), sig);
      });
      window.addEventListener('resize', () => {
        if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = requestAnimationFrame(() => {
          this.adaptHeight();
          if (this.isHints) this.goTo(this.index, false);
        });
      }, sig);
    }

    applyA11y() {
      this.slides.forEach((s, si) => {
        const inactive = si !== this.index;
        s.setAttribute('aria-hidden', inactive ? 'true' : 'false');
        s.querySelectorAll('a, button, video, input, select, textarea').forEach((f) => { f.tabIndex = inactive ? -1 : 0; });
      });
    }

    playActiveVideo() {
      this.slides.forEach((s, si) => {
        s.querySelectorAll('video').forEach((v) => {
          const visible = v.offsetParent !== null;
          if (si === this.index && visible) {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            v.pause();
          }
        });
      });
    }

    bindAutoplayGuards() {
      if (!this.autoplay || this.reduceMotion) return;
      const sig = { signal: this.ac.signal };
      this.addEventListener('mouseenter', () => { this.paused = true; this.stop(); }, sig);
      this.addEventListener('mouseleave', () => { this.paused = false; this.start(); }, sig);
      this.addEventListener('focusin', () => { this.paused = true; this.stop(); }, sig);
      this.addEventListener('focusout', () => { this.paused = false; this.start(); }, sig);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else if (!this.paused) this.start();
      }, sig);
    }

    bindEditorEvents() {
      if (!window.Shopify || !window.Shopify.designMode) return;
      const sig = { signal: this.ac.signal };
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const slide = e.target.closest('[data-lcw-slide-plus]');
        if (!slide) return;
        const i = this.slides.indexOf(slide);
        if (i >= 0) { this.stop(); this.goTo(i); }
      }, sig);
      document.addEventListener('shopify:block:deselect', (e) => {
        if (!this.contains(e.target)) return;
        this.restart();
      }, sig);
    }

    resetTimelineProgress() {
      if (this.progressAnim) {
        this.progressAnim.cancel();
        this.progressAnim = null;
      }
      this.pagItems.forEach((it) => {
        const bar = it.querySelector('.lcw-hero-plus__timeline-progress');
        if (bar) bar.style.width = '';
      });
    }

    startTimelineProgress() {
      if (this.pagStyle !== 'timeline') return;
      if (!this.autoplay || this.reduceMotion) return;
      const activeItem = this.pagItems[this.index];
      if (!activeItem) return;
      const bar = activeItem.querySelector('.lcw-hero-plus__timeline-progress');
      if (!bar || typeof bar.animate !== 'function') return;
      this.progressAnim = bar.animate(
        [{ width: '0%' }, { width: '100%' }],
        { duration: this.speed, fill: 'forwards', easing: 'linear' }
      );
    }

    bindTracking() {
      if (!this.gaEnabled) return;
      if (window.Shopify && window.Shopify.designMode) return;
      const sig = { signal: this.ac.signal };

      this.slides.forEach((s, i) => {
        const mediaLink = s.querySelector('a.lcw-hero-plus__media-link');
        if (mediaLink) {
          mediaLink.addEventListener('click', () => {
            if (this.moved) return;
            this.trackPromotion('select_promotion', s, i);
          }, sig);
        }
        s.querySelectorAll('.lcw-hero-plus__content-inner a, .lcw-hero-plus__content-inner button').forEach((el) => {
          el.addEventListener('click', () => {
            if (this.moved) return;
            this.trackPromotion('select_promotion', s, i);
          }, sig);
        });
      });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            this.inView = e.isIntersecting;
            if (e.isIntersecting) this.trackView(this.index);
          });
        }, { threshold: 0.5 });
        this.io.observe(this);
      } else {
        this.inView = true;
        this.trackView(this.index);
      }
    }

    trackView(i) {
      if (!this.gaEnabled || !this.inView) return;
      if (this.viewed.has(i)) return;
      this.viewed.add(i);
      this.trackPromotion('view_promotion', this.slides[i], i);
    }

    trackPromotion(eventName, slide, i) {
      if (!this.gaEnabled || !slide) return;
      const name = slide.dataset.promoName || slide.dataset.promoCreative || ('Slide ' + (i + 1));
      const creative = slide.dataset.promoCreative || '';
      const slot = this.gaLocation + '_' + (i + 1);
      const id = (slide.dataset.promoName || slot)
        .toString().trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '') || slot;

      const item = { promotion_id: id, promotion_name: name, creative_slot: slot, location_id: this.gaLocation };
      if (creative) item.creative_name = creative;
      const payload = { promotion_id: id, promotion_name: name, creative_slot: slot, location_id: this.gaLocation, items: [item] };

      if (this.gaMethod === 'pixel') {
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('lcw_' + eventName, payload);
          }
        } catch (e) {}
      }
      if (this.gaMethod === 'gtm' && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: eventName, ecommerce: { items: [item] } });
      }
      if (this.gaMethod === 'gtag' && typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
    }

    start() {
      this.stop();
      if (this.single || this.reduceMotion || !this.autoplay) return;
      this.timer = setInterval(() => this.next(), this.speed);
      this.resetTimelineProgress();
      this.startTimelineProgress();
    }
    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
      if (this.progressAnim) { try { this.progressAnim.pause(); } catch (e) {} }
    }
    restart() { if (!this.paused) this.start(); }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.ac) this.ac.abort();
    }
  }

  if (!customElements.get('lcw-hero-plus-slideshow')) {
    customElements.define('lcw-hero-plus-slideshow', LcwHeroPlusSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
